import { render } from "./TraderRequisitesSettingsModal.vue?vue&type=template&id=7523d054&ts=true"
import script from "./TraderRequisitesSettingsModal.vue?vue&type=script&lang=ts"
export * from "./TraderRequisitesSettingsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__